import {useAPI} from "../../../hooks/useAPI";
import {observer, useLocalObservable} from "mobx-react";
import {useContext, useEffect} from "react";
import React from "react";
import Page from "../../../components/Pages/Page";
import {formatX} from "../../../components/analytic/utils/formatX";
import {formatY} from "../../../components/analytic/utils/formatY";
import AnalyticPlacesLayout from "../../../containers/Statistic/analytic.places";
import {API_SystemManager} from "../../../api/systemManager";
import {AuthContext} from "../../../context/AuthContext";
import moment from "moment";
import {month} from "../../../components/CalendarV2/calendar/utils/dates";

export const PageAnalyticPlaces = observer(() => {
    const {APIRequest, loading} = useAPI()
    const userId = useContext(AuthContext)?.token?.userId

    const store = useLocalObservable(() => ({

        graph: null,
        setGraph: graph => store.graph = graph,

        list: [],
        setList: list => store.list = list,

        info: {},
        setInfo: info => store.info = info,

        dates: {
            startDate: new Date(),
            endDate: null,
            key: 'selection'
        },

        setDate: (date) => store.dates = date,

        period: "year",
        setPeriod: period => {
            store.period = period
            store.serverPeriod = ""
        },

        serverPeriod: "",
        setServerPeriod: period => store.serverPeriod = period,

        selectedId: "",
        setSelectedId: id => store.selectedId = id
    }))

    const setLayoutProps = () => {

        const info = store.info


        const blocks = {
            minimalCount: info?.min,
            maximumCount: info?.max,
            averageCount: info?.average,
            allErrors: info?.mistakes,
            allReading: info?.total,
            balance: info?.balance ? `${info?.balance} руб` : 0,
        }
        const readingStart = {hide: true}

        const chartTypes = {
            title: "Количество снимков",
            sortBar:
                {
                    options: [
                        {label: "Год", id: `year`, selected: "year" === store.period},
                        {label: "Месяц", id: `month`, selected: "month" === store.period},
                        {label: "Неделя", id: `week`, selected: "week" === store.period}
                    ],
                    onClick: store.setPeriod
                },
            graph: store?.graph?.length > 0 ? store.graph?.map(item => ({y: item.y, x: item.x})) : [{y: 0, x: 0}],
            formatX: (x) => {
                const customDates = ['day', 'days', "month", "week"]
                return formatX(x, customDates.includes(store.serverPeriod) ? store.serverPeriod : store.period)
            },
            formatY: (y) => formatY(y),
            onDateChange: e => {
                store.setPeriod("date")
                store.setDate(e)
            },
            date: store?.dates

        }
        const list = {
            options: store.list.map(item => ({label: item?.name, id: item?.id})),
            selected: store.selectedId,
            optionOnClickHandler: item => store.setSelectedId(item.id),
            categoryName: "",
            hideIcon: true
        }
        const breadCrumbs = [
            {link: "", title: "Активность"},
            {link: "", title: "Аналитика рентген кабинета", actual: true},
        ]

        return {
            blocks,
            readingStart,
            list,
            chartTypes,
            loading,
            breadCrumbs
        }
    }

//API
    const api = API_SystemManager.analytic_places

    const getList = async () => {
        await APIRequest(api.getPlaces(userId))
            .then(res => {
                if (res.status === 200) {
                    store.setList(res?.body?.data)
                    if (!store.selectedId && res?.body?.data?.length > 0) {
                        store.setSelectedId(res?.body?.data[0]?.id)
                    }
                }
            })
    }

    const getAnalytic = async () => {
        const start_date = moment(store.dates.startDate).format("YYYY-MM-DD")
        const end_date = moment(store.dates.endDate).format("YYYY-MM-DD")

        if (store.selectedId)

            await APIRequest(api.getStatistics(userId, store.selectedId, store.period, '', start_date, end_date || start_date))
                .then(res => {
                    if (res.status === 200) {
                        store.setInfo(res?.body?.data)
                    }
                })
    }

    const getGraph = async () => {
        const start_date = moment(store.dates.startDate).format("YYYY-MM-DD")
        const end_date = moment(store.dates.endDate).format("YYYY-MM-DD")

        await APIRequest(api.getStatistics(userId, store.selectedId, store.period, "graph", start_date, end_date || start_date))
            .then(res => {
                if (res.status === 200) {
                    store.setServerPeriod(res?.body?.data?.type)
                    store.setGraph(res?.body?.data?.graph)
                }
            })
    }

    const launchReading = async () => {
        await APIRequest(api.launchReading(userId, store.selectedId), null, {disableLoading: true})
            .then(res => {
                if (res.status === 200) {
                    store.setInfo({...store.info, isLaunched: res?.body?.data?.isLaunched})
                }
            })
    }


    useEffect(() => {
        getList()
    }, [])

    useEffect(() => {
        if (store.selectedId && store.period) {
            getAnalytic()
            getGraph()
        }
    }, [store.selectedId, store.period, store.dates.endDate])


    return (
        <Page mobile>
            <AnalyticPlacesLayout {...setLayoutProps()}/>
        </Page>

    )
})
